//Email suggestion (Requires mailcheck.js)
// ----------------------------------------------------------------------------
$(function () {
    if ($('input[type="email"]').length > 0) {
        $.cachedScript('//drive.coches.net/js/mailcheck.min.js').done(function () {

            $('input[type="email"]').on('keyup paste', function () {
                $('.suggest').remove();
                //var r = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
            });

            $('input[type="email"]').on('blur', function () {
                $('.suggest').remove();
                $(this).mailcheck({
                    suggested: function (element, suggestion) {
                        var o = $(element);
                        o.after('<label class="suggest">&iquest;Quisiste decir <a href="javascript:">' + suggestion.full + '</a>?</label>');
                    },
                    empty: function () {
                    }
                });
            });

            $('input[type="email"]').parent().on('click', '.suggest a', function () {
                var o = $(this);
                o.parent().parent().find('input[type="email"]').val(o.text());
                o.parent().remove();
            });

        });
    }
});
